import { render } from "./lstItems.vue?vue&type=template&id=056195ab"
import script from "./lstItems.vue?vue&type=script&lang=ts"
export * from "./lstItems.vue?vue&type=script&lang=ts"
script.render = render

export default script